// src/components/ContactForm.tsx
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';
import { Label } from '@/components/ui/label';

const ContactForm = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    gdprConsent: false
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.checked });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    
    // Form validation
    if (!formData.name || !formData.email || !formData.phone || !formData.message) {
      toast({
        title: "Napaka",
        description: "Prosimo, izpolnite vsa obvezna polja.",
        variant: "destructive"
      });
      return;
    }

    if (!formData.gdprConsent) {
      toast({
        title: "Napaka",
        description: "Za nadaljevanje morate soglašati s pogoji.",
        variant: "destructive"
      });
      return;
    }

    // Mock successful submission
    toast({
      title: "Sporočilo poslano",
      description: "Hvala za vaše sporočilo. Odgovorili vam bomo v najkrajšem možnem času.",
    });

    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: '',
      gdprConsent: false
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <Label htmlFor="name" className="block text-sm font-medium text-stone-700 mb-1">
          Ime in priimek *
        </Label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Vnesite vaše ime in priimek"
          className="w-full px-4 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-stone-500"
          required
        />
      </div>

      <div>
        <Label htmlFor="email" className="block text-sm font-medium text-stone-700 mb-1">
          E-pošta *
        </Label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Vnesite vaš e-poštni naslov"
          className="w-full px-4 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-stone-500"
          required
        />
      </div>

      <div>
        <Label htmlFor="phone" className="block text-sm font-medium text-stone-700 mb-1">
          Telefon *
        </Label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder="Vnesite vašo telefonsko številko"
          className="w-full px-4 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-stone-500"
          required
        />
      </div>

      <div>
        <Label htmlFor="message" className="block text-sm font-medium text-stone-700 mb-1">
          Sporočilo *
        </Label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          rows={5}
          placeholder="Vnesite vaše sporočilo"
          className="w-full px-4 py-2 border border-stone-300 rounded-md focus:outline-none focus:ring-2 focus:ring-stone-500"
          required
        ></textarea>
      </div>

      <div className="flex items-start">
        <input
          type="checkbox"
          id="gdprConsent"
          name="gdprConsent"
          checked={formData.gdprConsent}
          onChange={handleCheckboxChange}
          title="Soglasje za obdelavo podatkov"
          className="mt-1 mr-2"
          required
        />
        <Label htmlFor="gdprConsent" className="text-sm text-stone-600">
          Z oddajo obrazca soglašam, da KAMEN d.o.o. kot upravljavec osebnih podatkov obdeluje moje osebne podatke, ki sem jih navedel/-a v tem obrazcu, za namen priprave in posredovanja ponudbe ter morebitne nadaljnje komunikacije v zvezi z mojo zahtevo. *
        </Label>
      </div>

      <Button type="submit" variant="secondary" className="w-full py-3">
        Pošlji
      </Button>
    </form>
  );
};

export default ContactForm;